var styleDataHash = "c5e2dc9f";
const injectCss = () => {
  var css = `.sfo1n{--wds-font-size-body-medium:16px}.v7CxQ{--wds-button-size-medium-screen-small:24px;--wds-color-border-dark-primary:transparent;margin-inline-end:10px}.NCNy1{--wds-font-weight-bold:400}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var insert_decoration_modal_default = {
  "panelRoot": "sfo1n",
  "backButton": "v7CxQ",
  "footer": "NCNy1"
};
export {
  insert_decoration_modal_default as default,
  injectCss
};
//# sourceMappingURL=insert-decoration-modal-scss.js.map
